const { decodeHTMLEntities, encodeHTMLEntities, ImageWithCaptionModel, processText } = require("../helpers");
const { toHTML } = require("@portabletext/to-html");
const removeMD = require("remove-markdown");

module.exports = (props) => {
  const { image, imageOn, text } = props.value;
  const { footnotes } = props;

  const iwcModel = new ImageWithCaptionModel(image?.image, image?.caption, image?.fullCaption, "text with image");

  const marginClasses = {
    left: "@480/layout/margin:right:page",
    right: "@480/layout/margin:left:page",
  };

  const imageHtml = `
    <div class="
        layout/flex:shrink:disable 
        layout/align:start 
        layout/margin:top:baseline 
        layout/flex
        layout/width:100%
        @375/layout/width:clear
        @375/layout/width:max
        @375/layout/margin:top:clear
        @375/layout/margin:${imageOn === "left" ? "right" : "left"}:clear
        @480/layout/width:max
        ${marginClasses[imageOn]}
        @667/layout/width:max
      " style="
        --375--layout--width--max: 30%; --480--layout--width--max: calc((var(--page-width--layout) - var(--page-spacing--fixed)) / 2); --667--layout--width--max: var(--480--layout--width--max);
      ">
      <div class="
          $motion/transition:top:curve:linear
          $motion/transition:top:duration:100ms
          layout/bottom
          layout/sticky
          layout/top
          motion/transition
        " style="
          --layout--bottom: calc(var(--page-spacing) * 2);
          --layout--top:    calc(var(--header-height--current) - var(--header-height--chin) + var(--page-spacing) * 2);
          will-change: bottom, top;
        ">
        <div style="
            --picture--max-height: calc(var(--page-width--layout) * 3 / 4); --375--picture--max-height: calc(var(--page-width--layout) * 3 / 5); --landscape--picture--max-height: calc(var(--visible-height) - 11.4rem); --768--landscape--picture--max-height: calc(var(--visible-height) - 17.6rem); --tall--picture--max-height: calc(var(--page-width--layout) * 3 / 5);
          ">
          <picture class="picture">
            <img class="link/enable link/focus picture/image" src="${iwcModel.imageUrl()}" alt="${encodeHTMLEntities(removeMD(iwcModel.captionText()))}" draggable="false" oncontextmenu="return false;" role="button" loading="lazy" data-image-overlay-credit="${encodeHTMLEntities(processText(iwcModel.fullCaptionText(), image?.fullCaption))}" data-image-overlay-item="" data-image-overlay-src="${iwcModel.imageUrl()}" tabindex="0" ontouchstart="" onerror="window.MoMA.onImageError(this, 1)">
          </picture>
        </div>
        <div class="
            $color/alpha:54%
            $typography/baseline:body
            $typography/size:small
            $typography/weight:regular
            layout/margin:top:cap
          ">
          <p class="typography">
            <span class="layout/block balance-text">${processText(iwcModel.captionText(), image?.caption)}</span>
          </p>
        </div>
      </div>
    </div>
  `;

  const textHtml = toHTML(text, {
    components: {
      block: {
        normal: ({ children }) => `<p>${processText(decodeHTMLEntities(children))}</p>`,
        h3: ({ children }) => `<h3>${processText(decodeHTMLEntities(children))}</h3>`
      },
      types: {
        span: ({ children }) => `<span>${processText(decodeHTMLEntities(children))}</span>`,
        footnote: (props) => {
          footnotes.push(props.value);
          const footnoteId = footnotes.length;
          return `<sup class="footnote-ref" id="fnref:${footnoteId}">
              <a href="#fn:${footnoteId}" rel="footnote">${footnoteId}</a>
            </sup>`;
        },
      },
      marks: {
        strong: ({children}) => `<strong>${children}</strong>`,
        em: ({children}) => `<em>${children}</em>`,
        underline: ({children}) => `<u>${children}</u>`
      }
    }
  });

  const textContainerHtml = `
    <div class="
        layout/align:start
        layout/flex:column
        layout/width:100%
        @375/layout/width:clear
        @375/layout/width:max
        @375/layout/margin:top:clear
        @480/layout/width:max
        @667/layout/width:max
      " style="
        --375--layout--width--max: calc(70% - var(--page-spacing--fixed)); --480--layout--width--max: var(--uneven-column-width--main); --667--layout--width--max: var(--480--layout--width--max);
      ">
      <div class="
          $motion/transition:top:curve:linear
          $motion/transition:top:duration:100ms
          layout/bottom
          layout/sticky
          layout/top
          motion/transition
        " style="
          --layout--bottom: calc(var(--page-spacing) * 2);
          --layout--top:    calc(var(--header-height--current) - var(--header-height--chin) + var(--page-spacing) * 2);
          will-change: bottom, top;
          padding: 1rem 0.5rem;
        ">
        <div class="typography/markdown:headers typography">
          ${textHtml}
        </div>
      </div>
    </div>
  `;

  return `
    <div class="
        typography/markdown:headers
        layout/margin:top:baseline
        layout/justify:between
        @375/layout/flex:row
        layout/flex:column
        layout/width:100%
      ">
        ${imageOn === "left" ? imageHtml + textContainerHtml : textContainerHtml + imageHtml}
    </div>
  `;
};
